// extracted by mini-css-extract-plugin
export default {"wrapper":"_6a9a32ea"};